/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AttachmentSource = 'SYSTEM' | 'USER_UPLOADED' | 'USER_ACTION' | 'MICROSOFT';

export const AttachmentSource = {
    SYSTEM: 'SYSTEM' as AttachmentSource,
    USER_UPLOADED: 'USER_UPLOADED' as AttachmentSource,
    USER_ACTION: 'USER_ACTION' as AttachmentSource,
    MICROSOFT: 'MICROSOFT' as AttachmentSource
};

